<div class="modal-body text-center p-4">

  <!-- Exclamation icon -->
  <div class="icon-wrapper mx-auto mb-3">
    <i class="bi bi-exclamation-circle-fill text-danger" style="font-size: 3rem;"></i>
  </div>

  <!-- Title -->
  <h5 class="fw-bold mb-2">{{ modalData?.title || 'Confirm' }}</h5>

  <!-- Description -->
  <p class="text-muted mb-4">{{ modalData?.des }}</p>

  <!-- Buttons -->
  <div class="d-flex justify-content-center gap-3">
    <button
      type="button"
      class="btn btn-primary px-4"
      (click)="confirm(true)">
      {{ modalData?.confirmButtonText || 'Yes' }}
    </button>

    <button
      type="button"
      class="btn btn-outline-secondary px-4"
      (click)="confirm(false)">
      {{ modalData?.cancelButtonText || 'No' }}
    </button>
  </div>
</div>
